import { ThemeProvider, createTheme } from '@mui/material/styles';
import InternalSimulator from './InternalSimulator';
import ExternalSimulator from './ExternalSimulator';
import { useEffect, useState } from "react";
import groupBy from 'lodash/groupBy';
import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';
import {csv} from "d3-fetch";
import { Routes, Route } from "react-router-dom";

const theme = createTheme({
  palette: {
    mode: 'dark',
  },
  typography:{
    fontFamily: 'Overpass'
  }
});

function App() {
  const [controlMeasures, setControlMeasures] = useState();
  const [events, setEvents] = useState();
  const [impactCategories, setImpactCategories] = useState();
  const [localFactors, setLocalFactors] = useState();
  const [scores, setScores] = useState();
  const [bonusPointGroups, setBonusPointGroups] = useState();

  useEffect(() => {
    (async function() {
      setImpactCategories(mapValues(keyBy(await csv('./impact_categories.csv'), x => x.id), v => v.name));
      setControlMeasures(keyBy(await csv('./control_measures.csv'), x => x.id));
      setLocalFactors(mapValues(keyBy(await csv('./local_factors.csv'), x => x.id), v => v.name));

      const _bonusPointGroups = groupBy(await csv('./bonus_points.csv'), bp => bp.group);
      setBonusPointGroups(Object.values(_bonusPointGroups).map(v => ({ selected: '', questions: v.map(q => ({...q, score: +q.score})) })));

      const scoresCsv = await (await fetch('./scores.csv')).text();
      const _scores = scoresCsv.split('\n').map(r => r.split(',').map(s => +s));
      setScores(_scores);

      const _events = await csv('./events.csv');
      _events.forEach(e => {
        e.low = +e.low;
        e.high = +e.high;
      });
      setEvents(_events);
    })();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="/" element={
          <ExternalSimulator 
            controlMeasures={controlMeasures} 
            events={events}
            impactCategories={impactCategories}
            localFactors={localFactors}
            scores={scores}
            bonusPointGroups={bonusPointGroups}
          />}
        />
        <Route path="/internal" element={
          <InternalSimulator
            controlMeasures={controlMeasures} 
            events={events}
            impactCategories={impactCategories}
            localFactors={localFactors}
            scores={scores}
            bonusPointGroups={bonusPointGroups}
          />} 
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
